import axios from "axios";

export const croInstance = axios.create({
  baseURL: "/rest/v1",
});

croInstance.interceptors.request.use(
  (config) => {
    const apiKey = import.meta.env.VITE_CRO_API_KEY;

    if (apiKey) {
      config.headers["X-API-Key"] = apiKey;
    } else {
      console.warn("CRO API Key is missing. Requests may fail.");
    }

    return config;
  },
  (error) => Promise.reject(error),
);
